// extracted by mini-css-extract-plugin
export var compactFilters = "_jq-4";
export var detailImage = "_jq-1";
export var dropdownContainer = "_jq-2";
export var imageContainer = "_jq-0";
export var selectedCard = "_jq-3";